import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import { isEmpty, get } from 'lodash';
import Card from "../../Card/Card";
import CardHeader from "../../Card/CardHeader";
import CardText from "../../Card/CardText";
import Divider from "../../Divider/Divider";
import MoreOrLessButton from "../../MoreOrLessButton/MoreOrLessButton";
import { IntlProvider } from 'react-intl';
import Locations from "../../Location/Locations/Locations";
import ServiceAreas from "../../ServiceAreas/ServiceAreas";
import ProgramAcceptance from "../components/ProgramAcceptance/ProgramAcceptance";
import ProgramDescription from "../components/ProgramDescription/ProgramDescription";
import ProgramEligibility from "../../../legacy/ProgramEligibility/ProgramEligibility";
import ProgramUsersInfo from "../components/ProgramUsersInfo/ProgramUsersInfo";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ProgramDetails = props => {
  const {
    className = '',
    clickableAddress = false,
    feeScheduleProgramIconDetails = {},
    initiallyCollapsed = true,
    isFeeScheduleProgram = false,
    openLink = typeof window !== 'undefined' ? window.open : () => {},
    originLatLng = [],
    program: {
      locations = [],
      service_areas = [],
      name = '',
      receiving_referrals = false,
      status = ''
    },
    program = {},
    rightHeaderComponent = null,
    showProgramUsersInfo = false,
    intlProvider = {},
    showReferralStatus = true
  } = props;
  const RightHeaderComponent = rightHeaderComponent;
  const serviceAreas = !isEmpty(service_areas) && /*#__PURE__*/_jsx(ServiceAreas, {
    className: "m-5",
    service_areas: service_areas,
    intlProvider: intlProvider
  });
  return /*#__PURE__*/_jsx(IntlProvider, {
    defaultLocale: "en",
    locale: intlProvider.locale,
    messages: intlProvider.messages,
    children: /*#__PURE__*/_jsxs(Card, {
      className: cn('rounded border-light-border-blue', className),
      children: [/*#__PURE__*/_jsxs(CardHeader, {
        className: "text-lg text-text-blue font-regular-font border-b border-solid border-light-border-blue",
        headerIconDetails: feeScheduleProgramIconDetails,
        showHeaderIcon: isFeeScheduleProgram,
        title: name,
        subtitle: get(program, 'name_untranslated', ''),
        children: [showReferralStatus && /*#__PURE__*/_jsx(ProgramAcceptance, {
          receiving_referrals: receiving_referrals,
          status: status
        }), rightHeaderComponent && /*#__PURE__*/_jsx(RightHeaderComponent, {})]
      }), /*#__PURE__*/_jsx(CardText, {
        className: "bg-none max-h-full",
        containerStyle: {
          padding: '0px'
        },
        children: initiallyCollapsed ? /*#__PURE__*/_jsxs(MoreOrLessButton, {
          children: [/*#__PURE__*/_jsx(ProgramUsersInfo, {
            program: program,
            showProgramUsersInfo: showProgramUsersInfo
          }), /*#__PURE__*/_jsx(ProgramDescription, {
            className: "m-5",
            openLink: openLink,
            program: program
          }), !isEmpty(locations) && /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Locations, {
            className: "m-5",
            clickableAddress: clickableAddress,
            locations: locations,
            originLatLng: originLatLng,
            intlProvider: intlProvider
          }), (!isEmpty(locations) || !isEmpty(service_areas)) && /*#__PURE__*/_jsx(Divider, {}), serviceAreas, !isEmpty(service_areas) && /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ProgramEligibility, {
            className: "m-5",
            program: program
          })]
        }) : /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(ProgramUsersInfo, {
            program: program,
            showProgramUsersInfo: showProgramUsersInfo
          }), /*#__PURE__*/_jsx(ProgramDescription, {
            className: "m-5",
            openLink: openLink,
            program: program,
            showMore: true
          }), !isEmpty(locations) && /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Locations, {
            className: "m-5",
            clickableAddress: clickableAddress,
            locations: locations,
            originLatLng: originLatLng,
            intlProvider: intlProvider,
            showMore: true
          }), (!isEmpty(locations) || !isEmpty(service_areas)) && /*#__PURE__*/_jsx(Divider, {}), serviceAreas, !isEmpty(service_areas) && /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ProgramEligibility, {
            className: "m-5",
            program: program,
            showMore: true
          })]
        })
      })]
    })
  });
};
ProgramDetails.propTypes = {
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  initiallyCollapsed: PropTypes.bool,
  openLink: PropTypes.func,
  originLatLng: PropTypes.array,
  isFeeScheduleProgram: PropTypes.bool,
  feeScheduleProgramIconDetails: PropTypes.object,
  program: PropTypes.shape({
    name: PropTypes.string,
    receiving_referrals: PropTypes.bool,
    status: PropTypes.string,
    locations: PropTypes.array,
    service_areas: PropTypes.array,
    eligibility_text: PropTypes.string
  }).isRequired,
  /**
   * Property to pass a component that will render in the header.
   * This feature is used to render an edit program link in the upper right.
   */
  rightHeaderComponent: PropTypes.func,
  showProgramUsersInfo: PropTypes.bool,
  intlProvider: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.array
  }),
  showReferralStatus: PropTypes.bool
};
export default ProgramDetails;
//# sourceMappingURL=ProgramDetails.js.map